<template>
  <b-container>
    <div class="coordinators">
      <h1>Coordinators</h1>
      <div v-if="coordinators && coordinators.length > 0" class="table-wrap">
        <div>
          <router-link :to="{ name: 'NewCoordinator' }" class
            >+Add Coordinator</router-link
          >
        </div>
        <br />
        <b-row>
          <b-col>
            <b-form-group horizontal label="Search">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  placeholder="Type to Filter Coordinators"
                />
                <b-input-group-append>
                  <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group horizontal label="Sort">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-table
          v-cloak
          responsive
          :fields="fields"
          :items="coordinators"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
        >
          <template slot="cell(name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditCoordinator', params: { id: row.item.uuid } }"
            >
              {{ row.item.first_name }} {{ row.item.middle_name }}
              {{ row.item.last_name }}
            </b-link>
          </template>
          <template slot="cell(active)" slot-scope="row">
            <b-form-radio-group
              :id="row.index.toString()"
              :value="row.item.active"
              v-model="row.item.active"
              @change="updateCoordinator(row.item)"
            >
              <b-form-radio :value="true">True</b-form-radio>
              <b-form-radio :value="false">False</b-form-radio>
            </b-form-radio-group>
          </template>
          <template slot="cell(user_uuid)" slot-scope="row" >
              <b-link
                @click.stop="stopClick"
                :to="{ name: 'UserProfile', params: { id: row.item.user_uuid,type:'coordinator'} }"
              >
                  <b-button class="info">Edit User</b-button>
              </b-link>
              <br />
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="coordinatorCount || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
          <download-button
            :export="coordinatorsExport"
            :file="file"
          ></download-button>
        </b-row>
      </div>
      <div v-else>
        Coordinators are loading...
        <br />
        <br />
        <router-link
          v-bind:to="{ name: 'NewCoordinator' }"
          class="add_school_link"
          >+Add Coordinator</router-link
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapActions,mapGetters } from "vuex";
import CoordinatorService from "@/services/CoordinatorService";

export default {
  name: "CoordinatorsList",
  components: {
    DownloadButton: () => import("@/components/DownloadButton"),
  },
  data() {
    return {
      file: this.$route.path.slice(1),
      fields: [
        { key: "name", label: "Full Name" },
        { key: "sex", label: "Sex", sortable: true },
        { key: "designation", label: "Designation", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "active", label: "Active", sortable: true },
      ],
      currentPage: 0,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
    };
  },
  methods: {
    ...mapActions({
      GET_COORDINATORS: "coordinators/GET_COORDINATORS",
      GET_COORDINATORS_EXPORT: "coordinators/GET_COORDINATORS_EXPORT",
      GET_COORDINATOR_COUNT: "coordinators/GET_COORDINATOR_COUNT",
      RESET_COORDINATORS_STATE: "coordinators/RESET_COORDINATORS_STATE",
    }),
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
    async updateCoordinator(params) {
      const payload = await {
        id: params.id,
        active: !params.active,
      };
      await CoordinatorService.updateCoordinatorActive(payload);
    },
    log(item) {
      console.log(item);
    },
  },
  computed: {
    ...mapGetters({
        isAdmin: "auth/isAdmin",
        }),
    coordinators: {
      get() {
        return this.$store.state.coordinators.coordinators;
      },
    },
    coordinatorCount: {
      get() {
        return this.$store.state.coordinators.count;
      },
    },
    coordinatorsExport() {
      const data = this.coordinators.map((t) => {
        return {
          "1 - coordinator": `${t.first_name} ${t.middle_name} ${t.last_name} `,
          "2 - sex": t.sex,
          "3 - designation": t.designation,
          "4 - birthdate": t.birthdate,
          "5 - active": t.active,
          "6 - country": t.country,
          "7 - region": t.region,
          "8 - district": t.district,
          "9 - village": t.village,
        };
        return t;
      });
      return data.reduce((acc, val) => acc.concat(val), []);
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  watch: {
    currentPage: {
      handler(val) {
        console.log("watch: ", val);
        CoordinatorService.fetchCoordinators(val, this.perPage).catch((err) =>
          console.error(err)
        );
      },
    },
  },
  created() {
    this.GET_COORDINATORS();
    this.GET_COORDINATOR_COUNT();
    if(this.isAdmin){
      this.fields.push({key:"user_uuid", label:"Action"});
    }
  },
  mounted() {
    this.GET_COORDINATORS_EXPORT();
  },
};
</script>

<style scoped>
#coordinators {
  table-layout: fixed;
  width: 100%;
}
.name {
  width: 20%;
  white-space: nowrap;
}
.sex {
  width: 7.5%;
}
.designation {
  width: 10%;
}
.edit {
  width: 7.5%;
}

.table-wrap {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
table th,
table tr {
  text-align: center;
}
table thead {
  background: #bf9660;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_coordinator_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}
</style>
